import { render, staticRenderFns } from "./ManagerBlock.vue?vue&type=template&id=69043f23"
import script from "./ManagerBlock.vue?vue&type=script&lang=ts"
export * from "./ManagerBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports